// @mui icons
import Icon from '@mui/material/Icon'
// Material Dashboard 2 React layouts
import Dashboard from './dashboard'
import Onboard from './Onboard'
// import Tables from './tables'
// import Billing from './billing'
// import Notifications from './notifications'
import MarketplaceApps from './MarketplaceApps'
import Changelogs from './Changelogs'
import AllTheAppDescription from './AllTheAppDescription'
import ChangeLogsFolder from './ChangeLogsFolder'
import Newsfeeds from './Newsfeeds'
import Navigations from './Navigations'
import AppTriggerModel from './AppTriggerModel'
// import Roadmap from './'
import Webhooks from './Webhooks'
import ToolCategory from './toolCategory'
import Tools from './Tools'
import Players from './Players'
import Event from './Event'
import CompetionCat from './CompetionCat'
import CompetionPoints from './CompetionPoints'
import OnBoardFolder from './OnBoardFolder'
import PlayersCategory from './PlayersCategory'
import AppPlans from './Apps/plans'
import Demo from './Demo/Demo'
import AppsView from './Apps/View'
import Auth from './integration/auth/index'
import ApiDocs from './Docs'
import AgencyDocs from  "./AgencyDocs"
import LocationDocs from  "./LocationDocs"
import Categories from './Categories'
import ActionCategories from './ActionCategories'
import Types from './Types'
import Partner from './Partner'
import PartnerSaas from './PartnerSaas'
import BusinessTypes from './BusinessTypes'
import Tags from './Tags'
import Services from './Services'
// import GhlFeatures from './GhlFeatures'
import DashTags from './DashTags'
import OnbordingList from './OnbordingList'
import OnboardlistCategory from './OnboardlistCategory'

import InstructionChecklist from './InstructionChecklist'
import QuestionCategory from './QuestionCategory'
import QuestionChapters from './QuestionChapters'

import ChecklistCategory from './ChecklistCategory'
import ServicesCategory from './ServicesCategory'

import MediaLibrary from './MediaLibrary'
import MediaLibraryAgency from './MediaLibraryAgency'
import MediaLibraryCategory from './MediaLibraryCategory'
import MediaLibraryFolder from './MediaLibraryFolder'
import ConnectLocation from './ConnectLocation'
import Users from './Users'
import Locations from './Locations'
import Companies from './Companies'
import UnlimitedFaq from './UnlimitedFaq'
import LocationFaqs from './locationFaqs'
import Appinstalls from './Appinstalls'
import AppTokens from './AppTokens'
import SSO from './SSO'
import ToolTip from './ToolTip'
import Banners from './Banners'
import OnBoardCategory from './OnBoardCategory'
import QuestionGroup from './QuestionGroup'
import AwardGroup from './AwardGroup'
// import ChecklistGroup from './ChecklistGroup'
import AppLogs from './AppLogs'

import Languages from './Languages'
import AppTiers from './AppTiers'
import UpdateRequests from './UpdateRequests'
import AwardListing from './AwardListing'
import Agents from './Agents'
import AiSupportKnowladgeBase from './AiSupportKnowladgeBase'
import CreateApp from './Agents/CreateApp'

import Exchangepodcast from './Exchangepodcast'

import AwardRanking from './AwardRanking'
import AwardRankingCategory from './AwardRankingCategory'
import Snapshot from './Snap_shots'

import AppListingView from './AppListing/View'
import Staff from './Staff'
import StaffTasks from './StaffTasks'
import Tasks from './Tasks'

import AwardedCompanies from './AwardedCompanies'
import Faq from './Faq'
import K_faq from './k_faq'
import Notification from './Notification'
import { useUserInfo } from 'context/user'
import Plans from './Plans'
import UserIntegration from './UserIntegration'
import NfcBusiness from './nfc'
import NfcUsers from './nfcusers'
import NFCPackage from './nfc-package'
import Card from 'components/icons/card'
import Product from 'components/icons/product'
import ProductPage from './product/productpage'
import PartnerAppKeys from './PartnerAppKeys'
import NFCUSERICON from 'components/icons/nfcuser'
import UserInstalls from './UserInstalls'
import Roadmap from './RoadMap'
import RoadmapCompany from './RoadmapCompany'


function useRoutes() {
  const [user] = useUserInfo()
  console.log('user', user)

  const allRoutes = [
    {
      type: 'collapse',
      name: 'Dashboard',
      key: 'dashboard',
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: '/dashboard',
      component: <Dashboard />,
    },
    // {
    //   type: 'collapse',
    //   name: 'partnerapps',
    //   key: 'partnerapps',
    //   icon: <Icon fontSize="small">Tools</Icon>,
    //   route: '/partner',
    //   collapse: [
    //     {
    //       type: 'collapse',
    //       name: 'Apps',
    //       key: 'partner',
    //       icon: <Icon fontSize="small">Tools</Icon>,
    //       route: '/partner',
    //       component: <Partner />,
    //     },

    //     {
    //       type: 'collapse',
    //       name: 'toolcategory',
    //       key: 'toolcategory',
    //       icon: <Icon fontSize="small">Tool category</Icon>,
    //       route: '/toolcategory',
    //       component: <ToolCategory />,
    //     },
    //   ],
    // },
    // {
    //   type: 'collapse',
    //   name: 'Staff',
    //   key: 'staff',
    //   icon: <Icon fontSize="small">group</Icon>,
    //   route: '/staff/*',
    //   component: <Staff />,
    // },
    // {
    //   type: 'collapse',
    //   name: 'Partner App Keys',
    //   key: 'partner_app_keys',
    //   icon: <Icon fontSize="small">group</Icon>,
    //   route: '/partner_app_keys',
    //   component: <PartnerAppKeys />,
    // },
    // {
    //   type: 'collapse',
    //   name: 'Tasks',
    //   key: 'tasks',
    //   icon: <Icon fontSize="small">checklist</Icon>,
    //   route: '/tasks',
    //   component: <Tasks />,
    // },

    {
      type: 'collapse',
      name: 'Changelogs',
      key: 'changelogs',
      icon: <Icon fontSize="small">changelogs</Icon>,
      route: '/changelogs',
      component: <Changelogs />,
    },
    {
      type: 'collapse',
      name: 'AllTheApp Description',
      key: 'AllTheAppDescription',
      icon: <Icon fontSize="small">AllTheAppDescription</Icon>,
      route: '/AllTheAppDescription',
      component: <AllTheAppDescription />,
    },
    {
      type: 'collapse',
      name: 'ChangeLogs Folder',
      key: 'ChangeLogsFolder',
      icon: <Icon fontSize="small">ChangeLogsFolder</Icon>,
      route: '/ChangeLogsFolder/*',
      component: <ChangeLogsFolder />,
    },
    {
      type: 'collapse',
      name: 'Newsfeeds',
      key: 'newsfeeds',
      icon: <Icon fontSize="small">Newsfeeds</Icon>,
      route: '/newsfeeds',
      component: <Newsfeeds />,
    },
    {
      type: 'collapse',
      name: 'Snapshot',
      key: 'snapshot',
      icon: <Icon fontSize="small">SnapShot</Icon>,
      route: '/snapshot',
      component: <Snapshot />,
    },
    // {
    //   type: 'collapse',
    //   name: 'Road Map',
    //   key: 'road_map',
    //   icon: <Icon fontSize="small">map</Icon>,
    //   route: '/road-map',
    //   component: <RoadMap />,
    // },
    // {
    //   type: 'collapse',
    //   name: 'Webhooks',
    //   key: 'webhooks',
    //   icon: <Icon fontSize="small">webhooks</Icon>,
    //   route: '/webhooks',
    //   component: <Webhooks />,
    // },
    // {
    //   type: 'collapse',
    //   name: 'Plans',
    //   key: 'plans',
    //   icon: <Icon fontSize="small">plans</Icon>,
    //   route: '/plans',
    //   component: <Plans />,
    // },
    // {
    //   type: 'collapse',
    //   name: 'Integration',
    //   key: 'integration',
    //   icon: <Icon fontSize="small">integration</Icon>,
    //   route: '/integration',
    //   component: <UserIntegration />,
    // },
    {
      type: 'collapse',
      name: 'Tools',
      key: 'tools',
      icon: <Icon fontSize="small">Tools</Icon>,
      route: '/tools',
      collapse: [
        {
          type: 'collapse',
          name: 'tools',
          key: 'tools',
          icon: <Icon fontSize="small">Tools</Icon>,
          route: '/tools',
          component: <Tools />,
        },

        {
          type: 'collapse',
          name: 'toolcategory',
          key: 'toolcategory',
          icon: <Icon fontSize="small">Tool category</Icon>,
          route: '/toolcategory',
          component: <ToolCategory />,
        },
      ],
    },
        {
          type: 'collapse',
          name: 'User Installs',
          key: 'users',
          icon: <Icon fontSize="small">users</Icon>,
          route: '/user_installs',
          component: <UserInstalls />,
        },
    // {
    //   type: 'collapse',
    //   name: 'Competitions',
    //   key: 'competition',
    //   icon: <Icon fontSize="small">Competitions</Icon>,
    //   route: '/Categories',
    //   collapse: [
    //     {
    //       type: 'collapse',
    //       name: 'Categories',
    //       key: 'Categories',
    //       icon: <Icon fontSize="small">Categories</Icon>,
    //       route: '/Categories',
    //       component: <CompetionCat />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'Points',
    //       key: 'Points',
    //       icon: <Icon fontSize="small">Points</Icon>,
    //       route: '/Points',
    //       component: <CompetionPoints />,
    //     },
    //   ],
    // },
      // {
      //   type: 'collapse',
      //   name: 'Ai Agents',
      //   key: 'assistants',
      //   icon: <Icon fontSize="small">Agents</Icon>,
      //   route: '/ai/assistants/*',
      //   collapse: [
      //     {
      //       type: 'collapse',
      //       name: 'Assistants',
      //       key: 'ai_assistants',
      //       icon: <Icon fontSize="small">Assistants</Icon>,
      //       route: '/ai/assistants/*',
      //       component: <Agents />,
      //     },
      //     {
      //       type: 'collapse',
      //       name: 'Ai Support KB',
      //       key: 'ai_assistants',
      //       icon: <Icon fontSize="small">A</Icon>,
      //       route: '/ai/AiSupportKnowladgeBase/*',
      //       component: <AiSupportKnowladgeBase />,
      //     },
      //     // {
      //     //   type: 'collapse',
      //     //   name: 'toolcategory',
      //     //   key: 'toolcategory',
      //     //   icon: <Icon fontSize="small">Submissions</Icon>,
      //     //   route: '/ai/assistants/apps',
      //     //   component: <CreateApp />,
      //     // },
      //   ],
      // },
    {
      type: 'collapse',
      name: 'Players',
      key: 'players',
      icon: <Icon fontSize="small">Players</Icon>,
      route: '/players',
      collapse: [
        {
          type: 'collapse',
          name: 'players',
          key: 'players',
          icon: <Icon fontSize="small">Players</Icon>,
          route: '/players',
          component: <Players />,
        },

        {
          type: 'collapse',
          name: 'playercategory',
          key: 'playercategory',
          icon: <Icon fontSize="small">Player Category</Icon>,
          route: '/playercategory',
          component: <PlayersCategory />,
        },
      ],
    },
    // {
    //   type: 'collapse',
    //   name: 'Event',
    //   key: 'event',
    //   icon: <Icon fontSize="small">event</Icon>,
    //   route: '/event',
    //   component: <Event />,
    // },

    // {
    //   type: 'collapse',
    //   name: 'Partners',
    //   key: 'partner',
    //   icon: <Icon fontSize="small">partner</Icon>,
    //   route: '/partner',
    //   component: <Partner />,
    // },

    // {
    //   type: 'collapse',
    //   name: 'Partners',
    //   key: 'partner',
    //   icon: <Icon fontSize="small">Partners</Icon>,
    //   route: '/partner/*',
    //   collapse: [
    //     {
    //       type: 'collapse',
    //       name: 'Apps',
    //       key: 'partner',
    //       icon: <Icon fontSize="small">list</Icon>,
    //       route: '/partner/*',
    //       component: <Partner />,
    //     },
    //   ],
    // },

    // {
    //   type: 'collapse',
    //   name: 'Saas Configurator',
    //   key: 'partnersaas',
    //   icon: <Icon fontSize="small">Partners</Icon>,
    //   route: '/partnersaas/*',
    //   collapse: [
    //     {
    //       type: 'collapse',
    //       name: 'Apps',
    //       key: 'partnersaas',
    //       icon: <Icon fontSize="small">list</Icon>,
    //       route: '/partnersaas/*',
    //       component: <PartnerSaas />,
    //     },
    //   ],
    // },

    // {
    //   type: 'collapse',
    //   name: 'Agents',
    //   key: 'agents',
    //   icon: <Icon fontSize="small">agent</Icon>,
    //   route: '/agents',
    //   component: <Agents />,
    // },
    {
      type: 'collapse',
      name: 'Exchangepodcast',
      key: 'exchangepodcast',
      icon: <Icon fontSize="small">Exchangepodcast</Icon>,
      route: '/exchangepodcast',
      component: <Exchangepodcast />,
    },
    // {
    //   type: 'collapse',
    //   name: 'Media Library',
    //   key: 'MediaLibraryFolder',
    //   icon: <Icon fontSize="small">Media Library</Icon>,
    //   route: '/MediaLibraryFolder',
    //   component: <MediaLibraryFolder />,
    // },
    // {
    //   type: 'collapse',
    //   name: 'OnBoard Folder',
    //   key: 'onBoardFolder',
    //   icon: <Icon fontSize="small">OnBoard Folder</Icon>,
    //   route: '/onBoardFolder/*',
    //   component: <OnBoardFolder />,
    // },
    
  {
      type: 'collapse',
      name: 'Roadmap',
      key: 'roadmap',
      icon: <Icon fontSize="small">roadmap</Icon>,
      route: '/roadmap/*',
      collapse: [
        {
          type: 'collapse',
          name: 'roadmap',
          key: 'roadmap',
          icon: <Icon fontSize="small">roadmap</Icon>,
          route: '/roadmap',
          component: <Roadmap />,
        },
        {
          type: 'collapse',
          name: 'Roadmap Details',
          key: 'roadmap_details',
          icon: <Icon fontSize="small">roadmap</Icon>,
          route: '/roadmap_details',
          component: <RoadmapCompany />,
        },

      ],
    },

    // {
    //   type: 'collapse',
    //   name: 'Services',
    //   key: 'services',
    //   icon: <Icon fontSize="small">build</Icon>,
    //   route: '/services',
    //   collapse: [
    //     {
    //       type: 'collapse',
    //       name: 'All Services',
    //       key: 'services-list',
    //       icon: <Icon fontSize="small">construction</Icon>,
    //       route: '/services',
    //       component: <Services />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'Categories',
    //       key: 'services-category',
    //       icon: <Icon fontSize="small">category</Icon>,
    //       route: '/servicescategory',
    //       component: <ServicesCategory />,
    //     },
    //   ],
    // },
    // {
    //   type: 'collapse',
    //   name: 'Marketplace',
    //   key: 'marketplace_apps',
    //   icon: <Icon fontSize="small">local_mall</Icon>,
    //   route: '/marketplace_apps/*',
    //   collapse: [
    //     {
    //       type: 'collapse',
    //       name: 'Marketplace Apps',
    //       key: 'marketplace_apps',
    //       icon: <Icon fontSize="small">list</Icon>,
    //       route: '/marketplace_apps/*',
    //       component: <MarketplaceApps />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'App Trigger Model',
    //       key: 'app_trigger_model',
    //       icon: <Icon fontSize="small">list</Icon>,
    //       route: '/app_trigger_model/*',
    //       component: <AppTriggerModel />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'App Tiers',
    //       key: 'app_tiers',
    //       icon: <Icon fontSize="small">description</Icon>,
    //       route: '/apps_tiers',
    //       component: <AppTiers />,
    //     },
        {
          type: 'collapse',
          name: 'App Requests',
          key: 'update_requests',
          icon: <Icon fontSize="small">markunread</Icon>,
          route: '/update_requests',
          component: <UpdateRequests />,
        },
    //     {
    //       type: 'collapse',
    //       name: 'Categories',
    //       key: 'categories',
    //       icon: <Icon fontSize="small">category</Icon>,
    //       route: '/categories',
    //       component: <Categories />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'Apps Collections',
    //       key: 'apps_collections',
    //       icon: <Icon fontSize="small">category</Icon>,
    //       route: '/apps_collections',
    //       component: <ActionCategories />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'Types',
    //       key: 'types',
    //       icon: <Icon fontSize="small">assignment_ind</Icon>,
    //       route: '/types',
    //       component: <Types />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'Tags',
    //       key: 'tags',
    //       icon: <Icon fontSize="small">label</Icon>,
    //       route: '/tags',
    //       component: <Tags />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'Business Types',
    //       key: 'businesstypes',
    //       icon: <Icon fontSize="small">business</Icon>,
    //       route: '/businesstypes',
    //       component: <BusinessTypes />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'Dashboard Tags',
    //       key: 'dashboardtags',
    //       icon: <Icon fontSize="small">label</Icon>,
    //       route: '/dashboardtags',
    //       component: <DashTags />,
    //     },
    //   ],
    // },
    {
      type: 'collapse',
      name: 'Media library',
      key: 'medialibrary',
      icon: <Icon fontSize="small">image</Icon>,
      route: '/medialibrary',
      collapse: [
        {
          type: 'collapse',
          name: 'Category',
          key: 'medialibrarycategory',
          icon: <Icon fontSize="small">category</Icon>,
          route: '/medialibrarycategory',
          component: <MediaLibraryCategory />,
        },
        {
          type: 'collapse',
          name: 'Library',
          key: 'medialibrary-list',
          icon: <Icon fontSize="small">list</Icon>,
          route: '/medialibrary',
          component: <MediaLibrary />,
        },
        {
          type: 'collapse',
          name: 'Agency Videos',
          key: 'medialibrary-list',
          icon: <Icon fontSize="small">list</Icon>,
          route: '/medialibraryagency',
          component: <MediaLibraryAgency />,
        },
      ],
    },

    {
      type: 'collapse',
      name: 'Location Knowledge Base',
      key: 'knowledgebase',
      icon: <Icon fontSize="small">menu_book</Icon>,
      route: '/location_knowledgebase/*',
      collapse: [
        {
          type: 'collapse',
          name: 'Knowledge Base',
          key: 'knowledgebase-list',
          icon: <Icon fontSize="small">article</Icon>,
          route: '/location_knowledgebase/*',
          component: <LocationDocs />,
        },
        // {
        //   type: 'collapse',
        //   name: 'Languages',
        //   key: 'languages',
        //   icon: <Icon fontSize="small">language</Icon>,
        //   route: '/languages/*',
        //   component: <Languages />,
        // },
        // {
        //   type: 'collapse',
        //   name: 'FAQs',
        //   key: 'k_faq',
        //   icon: <Icon fontSize="small">list</Icon>,
        //   route: '/k_faq',
        //   component: <K_faq />,
        // },
      ],
    },
    {
      type: 'collapse',
      name: 'Agency Knowledge Base',
      key: 'agency_knowledgebase',
      icon: <Icon fontSize="small">menu_book</Icon>,
      route: '/agency_knowledgebase/*',
      collapse: [
        {
          type: 'collapse',
          name: 'Knowledge Base',
          key: 'knowledgebase-list-agency',
          icon: <Icon fontSize="small">article</Icon>,
          route: '/agency_knowledgebase/*',
          component: <AgencyDocs />,
        },
        // {
        //   type: 'collapse',
        //   name: 'Languages',
        //   key: 'languages',
        //   icon: <Icon fontSize="small">language</Icon>,
        //   route: '/languages/*',
        //   component: <Languages />,
        // },
        // {
        //   type: 'collapse',
        //   name: 'FAQs',
        //   key: 'k_faq',
        //   icon: <Icon fontSize="small">list</Icon>,
        //   route: '/k_faq',
        //   component: <K_faq />,
        // },
      ],
    },

    {
      type: 'collapse',
      name: 'Onboard list',
      key: 'onboardcategory',
      icon: <Icon fontSize="small">Onboard</Icon>,
      route: '/onboarding/*',
      component: <OnBoardCategory />,
    },
    {
      type: 'collapse',
      name: 'Questions',
      key: 'questions',
      icon: <Icon fontSize="small">Questions</Icon>,
      route: '/questionsgroup/*',
      component: <QuestionGroup />,
    },
    // {
    //   type: 'collapse',
    //   name: 'Award Ranking',
    //   key: 'awardgroup',
    //   icon: <Icon fontSize="small">Award Ranking</Icon>,
    //   route: '/awardsgroup/*',
    //   component: <AwardGroup />,
    // },
    // {
    //   type: 'collapse',
    //   name: 'Check List',
    //   key: 'checklist',
    //   icon: <Icon fontSize="small">Checklist</Icon>,
    //   route: '/checklistgroup/*',
    //   component: <ChecklistGroup />,
    // },
    {
      type: 'collapse',
      name: 'FAQs',
      key: 'faq',
      icon: <Icon fontSize="small">help_outline</Icon>,
      route: '/faq',
      collapse: [
        // {
        //   type: 'collapse',
        //   name: 'Location FAQs',
        //   key: 'faq-list',
        //   icon: <Icon fontSize="small">list</Icon>,
        //   route: '/faq',
        //   component: <Faq />,
        // },
        {
          type: 'collapse',
          name: 'Agency FAQs',
          key: 'unlimited_faq',
          icon: <Icon fontSize="small">list</Icon>,
          route: '/unlimited_faq',
          component: <UnlimitedFaq />,
        },
        {
          type: 'collapse',
          name: 'Locations FAQs',
          key: 'location_faqs',
          icon: <Icon fontSize="small">list</Icon>,
          route: '/location_faqs',
          component: <LocationFaqs />,
        },
      ],
    },
    // {
    //   type: 'collapse',
    //   name: 'GHL Data',
    //   key: 'users',
    //   icon: <Icon fontSize="small">bar_chart</Icon>,
    //   route: '/users',
    //   collapse: [
    //     {
    //       type: 'collapse',
    //       name: 'Users',
    //       key: 'users',
    //       icon: <Icon fontSize="small">group</Icon>,
    //       route: '/users',
    //       component: <Users />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'Locations',
    //       key: 'locations',
    //       icon: <Icon fontSize="small">place</Icon>,
    //       route: '/locations',
    //       component: <Locations />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'Companies',
    //       key: 'companies',
    //       icon: <Icon fontSize="small">business</Icon>,
    //       route: '/companies',
    //       component: <Companies />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'App Logs',
    //       key: 'applogs',
    //       icon: <Icon fontSize="small">list</Icon>,
    //       route: '/applogs',
    //       component: <AppLogs />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'Appinstalls',
    //       key: 'appinstalls',
    //       icon: <Icon fontSize="small">list</Icon>,
    //       route: '/appinstalls',
    //       component: <Appinstalls />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'App Tokens',
    //       key: 'apptokens',
    //       icon: <Icon fontSize="small">list</Icon>,
    //       route: '/apptokens',
    //       component: <AppTokens />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'SSO',
    //       key: 'sso',
    //       icon: <Icon fontSize="small">list</Icon>,
    //       route: '/sso',
    //       component: <SSO />,
    //     },
    //     // {
    //     //   type: 'collapse',
    //     //   name: 'GHL Features',
    //     //   key: 'ghlfeatures',
    //     //   icon: <Icon fontSize="small">construction</Icon>,
    //     //   route: '/ghlfeatures',
    //     //   component: <GhlFeatures />,
    //     // },
    //   ],
    // },

    // {
    //   type: 'collapse',
    //   name: 'Awarded Companies',
    //   key: 'awards',
    //   icon: <Icon fontSize="small">emoji_events</Icon>,
    //   route: '/award-companies',
    //   component: <AwardedCompanies />,
    // },
    {
      type: 'collapse',
      name: 'ToolTip',
      key: 'tooltip',
      icon: <Icon fontSize="small">list</Icon>,
      route: '/tooltip/*',
      component: <ToolTip />,
    },
    {
      type: 'collapse',
      name: 'Support ',
      key: 'support',
      icon: <Icon fontSize="small">list</Icon>,
      route: '/support/*',
      component: <ConnectLocation />,
    },
    // {
    //   type: 'collapse',
    //   name: 'NFC Card',
    //   key: 'product_page',
    //   icon: (
    //     <Icon fontSize="medium" sx={{ mb: '10px' }}>
    //       <Card />
    //     </Icon>
    //   ),
    //   route: '/businessCard/*',
    //   component: <NfcBusiness />,
    // },
    // {
    //   type: 'collapse',
    //   name: 'NFC Users',
    //   key: 'nfc_users',
    //   icon: (
    //     <Icon fontSize="medium" sx={{ mb: '10px' }}>
    //       <NFCUSERICON />
    //     </Icon>
    //   ),
    //   route: '/nfcusers/*',
    //   component: <NfcUsers />,
    // },
    // {
    //   type: 'collapse',
    //   name: 'NFC Package',
    //   key: 'nfc_package',
    //   icon: (
    //     <Icon fontSize="medium" sx={{ mb: '10px' }}>
    //       <NFCUSERICON />
    //     </Icon>
    //   ),
    //   route: '/nfcPackage/*',
    //   component: <NFCPackage />,
    // },
    // {
    //   type: 'collapse',
    //   name: 'Products',
    //   key: 'product_page',
    //   icon: (
    //     <Icon fontSize="medium" sx={{ mb: '10px' }}>
    //       <Product />
    //     </Icon>
    //   ),
    //   route: '/products/*',
    //   component: <ProductPage />,
    // },
    {
      key: 'apps',
      route: '/apps/:app_id',
      component: <AppsView />,
    },
    {
      key: 'apps',
      route: '/apps/:app_id',
      component: <AppsView />,
    },
    {
      key: 'apps',
      route: '/apps/plans/:app_id',
      component: <AppPlans />,
    },
    {
      key: 'app_list_view',
      route: '/apps_listing/:app_id',
      component: <AppListingView />,
    },
    {
      key: 'theme',
      route: '/theme',
      component: <Demo />,
    },
    {
      key: 'auth',
      route: '/auth',
      component: <Auth />,
    },
  ]

  // Only allow "superadmin" and "manager" to see all routes
  const allowedRoles = ['superadmin', 'manager']

  if (user?.roles?.some((role) => allowedRoles.includes(role))) {
    return allRoutes // Full access for superadmin/manager
  }

  if (user?.roles?.some((role) => role === 'onboarding_admin')) {
    const allowedKeys = new Set([
      'changelogs', // Changelogs
      'newsfeeds', // News feed
      'players', // Players (+ sub-routes)
      'partner', // Partners
      'medialibrary', // Media library (+ sub-routes)
      'awardgroup', // Award Ranking (+ sub-routes)
      'banners', // Banners (unique key)
      'tooltip', // ToolTip (unique key)
      'checklist', // Check list (+ sub-routes)
      'questions', // Questions (+ sub-routes)
      'faq', // FAQs (+ sub-routes)
      'knowledgebase', // Knowledge Base (+ sub-routes)
      'onboardcategory', // Onboard list (+ sub-routes)
    ])

    return allRoutes.filter((route) => allowedKeys.has(route.key))
  }
  if (user?.roles?.some((role) => role === 'client')) {
    const allowedKeys = new Set([
      'partner', // Partners
    ])

    return allRoutes.filter((route) => allowedKeys.has(route.key))
  }
  if (user?.roles?.some((role) => role === 'bid_data')) {
    const allowedKeys = new Set([
      'partner', // Partners
      'partnersaas',
    ])

    return allRoutes.filter((route) => allowedKeys.has(route.key))
  }

  // Fallback for non-admin users (e.g., regular users)
  return [
    {
      type: 'collapse',
      name: 'Dashboard',
      key: 'dashboard',
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: '/dashboard',
      component: <Dashboard />,
    },
    {
      type: 'collapse',
      name: 'Tasks',
      key: 'tasks',
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: '/tasks',
      component: <Tasks />,
    },
    {
      type: 'collapse',
      name: 'Staff task',
      key: 'staff_task',
      icon: <Icon fontSize="small">Staff Task</Icon>,
      route: '/staff_task',
      component: <StaffTasks />,
    },
  ]
}

export default useRoutes
